import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NotificationsService, NotificationSummary } from 'src/app/features/notifications';
import { helperService } from 'src/app/utils/helper';

@Component({
    selector: 'app-notification-center',
    templateUrl: './notification-center.component.html',
    styleUrls: ['./notification-center.component.scss'],
    standalone: false
})
export class NotificationCenterComponent implements OnInit {

  private destroy$ = new Subject<void>();
  submittingIds = new Set<string>();
  markingIds = new Set<string>();
  notificationSubscription: any = null;
  lastTableLazyLoadEvent: any = null;
  notifications: any[] = [];
  totalRecords: number = 0;
  isLoading: boolean = false;
  constructor(private notificationsService: NotificationsService,private helperService: helperService, 
      private router: Router) { }

  ngOnInit(): void {
    // Subscribe to notification summary updates
    // this.notificationsService.getDashboardNotifications(999999)
    //   .subscribe(summary => {
    //     this.notificationSummary = summary;
    //     this.notificationSummary.notifications = this.classifyNotifications(summary.data.notifications);
    //     console.log('Received notification summary update:', summary);
    //   }); 

    // // Start polling for notifications
    // this.notificationsService.startPolling();
  }
  classifyNotifications(notifications: any[]): any[] {
    return notifications.map(notification => {
      let displayText = '';
      if(notification.targetType?.toUpperCase()==="TASK NOTIFICATION" && notification.createdBy.toUpperCase()=="REMINDER JOB"){
        displayText = `Reminder on Task ID ${notification.targetId}`;
      }else if(notification.targetType?.toUpperCase()==="PROJECT NOTIFICATION" && notification.createdBy.toUpperCase()=="REMINDER JOB"){
        displayText = `Reminder on Project ID ${notification.targetId}`;
      } else if (notification.targetType.toUpperCase() === 'TASK') {
        displayText = `Comment on Task #${notification.targetId}`;
      } else if (notification.targetType.toUpperCase() === 'PROJECT') {
        displayText = `Comment on Project #${notification.targetId}`;
      } else if (notification.targetType.toUpperCase() === 'TASK NOTIFICATION - RTC') {
        displayText = `Ready To Complete Task #${notification.targetId}`;
      } else {
        displayText = `New notification for ${notification.targetType} #${notification.targetId}`;
      }
      return {
        ...notification,
        displayText
      };
    });

  }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.notificationsService.stopPolling();
  }

  markAsRead(notificationId: string): void {
    this.markingIds.add(notificationId);
    this.notificationsService.markAsReadAndUpdate(Number(notificationId)).subscribe(
      () => {
        this.markingIds.delete(notificationId);
        console.log(`Notification ${notificationId} marked as read successfully.`);
        this.loadNotifications(this.lastTableLazyLoadEvent);
        // Optionally, you can also remove the notification from the local summary immediately
      },
      error => {
        console.error(`Error marking notification ${notificationId} as read:`, error);
      }
    );
  }

  dismissNotification(notificationId: string): void {
    this.submittingIds.add(notificationId);
    this.notificationsService.dismissNotification(Number(notificationId)).subscribe(
      () => {
        this.submittingIds.delete(notificationId);
        console.log(`Notification ${notificationId} dismissed successfully.`);
        this.loadNotifications(this.lastTableLazyLoadEvent);
        // Optionally, you can also remove the notification from the local summary immediately
      },
      error => {
        console.error(`Error dismissing notification ${notificationId}:`, error);
      }
    );
  }


    navigateToTarget(notification: any): void {
      // Handle notification click - navigate to the relevant task/project
      
      // Navigate to task grid and open comments modal for the specific task
      if (notification.targetType === 'Task') {
        const currentUrl = this.router.url;
        const targetRoute = '/task-grid';
        // Add timestamp to make each navigation unique
        const timestamp = Date.now();
        const queryParams = { 
          openComments: notification.targetId,
          t: timestamp // Unique timestamp to force route change
        };
        
        if (currentUrl.includes(targetRoute)) {
          // Already on task grid, just update query params
          this.router.navigate([targetRoute], { 
            queryParams: queryParams
            // Don't specify queryParamsHandling to replace all params
          });
        } else {
          // Navigate to task grid with query params
          this.router.navigate([targetRoute], { 
            queryParams: queryParams
          });
        }
      } else if (notification.targetType === 'TASK NOTIFICATION - RTC' ||notification.targetType=="TASK NOTIFICATION") {
        const targetRoute = '/task-grid';
        // Add timestamp to make each navigation unique
        const timestamp = Date.now();
        const queryParams = { 
          taskId: notification.targetId,
          type: notification.targetType=== 'TASK NOTIFICATION - RTC' ? 'rtc' : 'notification', // Pass the type to differentiate in task grid
          t: timestamp // Unique timestamp to force route change
        };
        
        this.router.navigate([targetRoute], { queryParams: queryParams });
      } else if (notification.targetType === 'PROJECT' || notification.targetType === "PROJECT NOTIFICATION") {
        const targetRoute = '/projects';
        // Add timestamp to make each navigation unique
        const timestamp = Date.now();
        const queryParams = {
          projectId: notification.targetId,
          t: timestamp // Unique timestamp to force route change
        };
        
        this.router.navigate([targetRoute], { queryParams: queryParams });
      }
    }

  isClickable(notification: any): boolean {
    const targetType = notification.targetType?.toUpperCase();
    const createdBy = notification.createdBy?.toUpperCase();
    return true;

    // If it's a reminder job, it is NEVER clickable
    if (createdBy === 'REMINDER JOB' &&!(targetType ==='TASK NOTIFICATION - RTC')) {
      return false;
    }

    // Only allow clicking if it's a TASK or PROJECT comment
    return targetType === 'TASK' || targetType === 'PROJECT'||targetType ==='TASK NOTIFICATION - RTC';
  }

  loadNotifications(event: any) {
    this.isLoading = true;
    this.lastTableLazyLoadEvent = event;
    event.first = event.first ? event.first : 1;
    event.rows = event.rows ? event.rows : 10;
    if (this.notificationSubscription)
      this.notificationSubscription.unsubscribe();
    let payload = this.helperService.generateEventPayload(event);
    this.notificationSubscription = this.notificationsService.getNotificationsPaginated(Math.floor(event.first / event.rows + 1), event.rows, payload).subscribe(res => {
      this.notifications = this.classifyNotifications(res.data);
      this.totalRecords = res.customValues.totalNumberOfRecords;
      this.isLoading = false;
    }, error => {
      console.error('Error loading notifications:', error);
      this.isLoading = false;
    });

  }
}
